export default __webpack_public_path__ + "static/media/workouts_icon_black.a1f50947.svg";